import type { ReactNode } from 'react'
import { CheckIcon } from '@/shared/ui/icons/CheckIcon'

export function SelectList({
  label,
  size = 'small',
  isSelected = false,
  isDisabled = false,
  leftIcon,
  shortcut,
  onSelect,
  className = '',
}: {
  label: ReactNode
  size?: 'small' | 'medium'
  isSelected?: boolean
  isDisabled?: boolean
  leftIcon?: ReactNode
  shortcut?: string
  onSelect?: () => void
  className?: string
}) {
  const box = size === 'medium' ? 'h-10 gap-2' : 'h-8 gap-1'
  const tone = isDisabled
    ? 'text-white-800 cursor-not-allowed'
    : 'text-black-700 hover:bg-white-200 cursor-pointer'

  return (
    <button
      type="button"
      className={`flex w-full items-center rounded-md px-2 py-[7px] text-left text-body-sm ${box} ${tone} ${className}`}
      disabled={isDisabled}
      aria-selected={isSelected}
      role="option"
      onClick={onSelect}
    >
      {leftIcon !== undefined && (
        <span className="flex shrink-0 items-center [&>svg]:h-5 [&>svg]:w-5" aria-hidden>
          {leftIcon}
        </span>
      )}
      <span className="min-w-0 flex-1 truncate">{label}</span>
      {shortcut !== undefined && (
        <span className="shrink-0 text-label text-black-100">{shortcut}</span>
      )}
      {isSelected && (
        <span className="flex shrink-0 items-center [&>svg]:h-4 [&>svg]:w-4" aria-hidden>
          <CheckIcon />
        </span>
      )}
    </button>
  )
}
